import { adios } from '@adserve/adserve-react-components';
import axios from 'axios';
import { starter2Api } from '../../../constants/Endpoint';

export const GetCampaignStaticData = async () => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignStaticData`)
    );

    return { ...results?.data, algorithms: [{ id: 1, name: 'Heuristic' }] };
};

export const SearchCampaignsByNameStarts = async (searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/Campaigns/SearchByNameStarts`, {
            params: {
                ...params,
                name: encodeURIComponent(searchTerm)
            }
        })
    );
    return results.data;
};

export const SearchBurstCampaignsByNameStarts = async (parentCampaignId, searchTerm, params) => {
    const results = await adios(() =>
        axios.get(`${starter2Api}/CampaignBursts/SearchByNameStarts`, {
            params: {
                ...params,
                parentCampaignId,
                name: searchTerm,
                excludeDeleted: true
            }
        })
    );
    return results.data;
};
